export enum FeatureFlags {
  approveJobsRedesign = 'approve_jobs_redesign',
  bulkSendDayButton = 'bulk_send_day_button',
  chargeBasedSettlements = 'charge_based_settlements',
  commandAlkonIntegration = 'command_alkon_integration',
  companyOnboarding = 'company_onboarding',
  csvOrderImport = 'csv_order_import',
  csvProjectImport = 'csv_project_import',
  csvTicketImport = 'csv_ticket_import',
  defaultVendorRateToDriver = 'default_vendor_rate_to_driver',
  dispatchGridView = 'dispatch_grid_view',
  dispatchSmartAutoRefresh = 'dispatch_smart_auto_refresh',
  driverAgent = 'driver_agent',
  fastWeighEnabled = 'fast_weigh_enabled',
  geofenceReportsEnabled = 'geofence_reports_enabled',
  hideDocumentTypes = 'hide_document_types',
  hideDriversVendorNameIfOwnerOperator = 'hide_drivers_vendor_name_if_owner_operator',
  inAppMessaging = 'in_app_messaging',
  liveEtaEnabled = 'live_eta_enabled',
  llmQuickOrder = 'llm_quick_order',
  loadDigestPdf = 'load_digest_pdf',
  loadLevelPricing = 'load_level_pricing',
  matchKeysEnabled = 'match_keys_enabled',
  orderFormStartTimeDefaultTo7am = 'order_form_start_time_default_to_7am',
  orderFormStartTimeDefaultToNull = 'order_form_start_time_default_to_null',
  payCommissions = 'pay_commissions',
  projectMaterialRateSeeding = 'project_material_rate_seeding',
  qbItemMatchLlm = 'qb_item_match_llm',
  qbSharedChildConnection = 'qb_shared_child_connection',
  quickDepartmentFilters = 'quick_department_filters',
  renameDispatchNoToCustomerRefPo = 'rename_dispatch_no_to_customer_ref_po',
  routeOptimization = 'route_optimization',
  selectiveRateApplicationDefault = 'selective_rate_application_default',
  serverQuotePdf = 'server_quote_pdf',
  showHaulerRateTypeCard = 'show_hauler_rate_type_card',
  simulateOrder = 'simulate_order',
  stagingWaypoint = 'staging_waypoint',
  switchAssigneeTabsOrder = 'switch_assignee_tabs_order',
  ticketNumberOptionalOnWeb = 'ticket_number_optional_on_web',
  timesheetTab = 'timesheet_tab',
  tomlinsonOrderFormProjectFirst = 'tomlinson_orderform_project_first',
  tomlinsonOrderModal = 'tomlinson_order_modal',
  treadAgent = 'tread_agent',
  typedTruckCapacityV1 = 'typed_truck_capacity_v1',
  useNewTimesheet = 'use_new_timesheet',
  vendorJobSplittingEnabled = 'vendor_job_splitting_enabled',
  vetaCenterIntegration = 'veta_center_integration',
}
